import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { droplistService } from 'services';

const initialState = {
  statusBloodType: 'pending',
  listBloodType: [],
  statusCountry: 'pending',
  listCountry: [],
  statusGender: 'pending',
  listGender: [],
  statusRace: 'pending',
  listRace: [],
  statusReligion: 'pending',
  listReligion: [],
  statusNationality: 'pending',
  listNationality: [],
};

export const getBloodTypeDL = createAsyncThunk(
  'droplist/fetchBloodType',
  async () => {
    const response = await droplistService.getBloodTypeDL();
    return response;
  }
);

export const getCountryDL = createAsyncThunk(
  'droplist/fetchCountry',
  async () => {
    const response = await droplistService.getCountryDL();
    return response;
  }
);

export const getGenderDL = createAsyncThunk(
  'droplist/fetchGender',
  async () => {
    const response = await droplistService.getGenderDL();
    return response;
  }
);

export const getRaceDL = createAsyncThunk(
  'droplist/fetchRace',
  async () => {
    const response = await droplistService.getRaceDL();
    return response;
  }
);

export const getReligionDL = createAsyncThunk(
  'droplist/fetchReligion',
  async () => {
    const response = await droplistService.getReligionDL();
    return response;
  }
);

export const getNationalityDL = createAsyncThunk(
  'droplist/fetchNationality', async () => {
    const response = await droplistService.getNationalityDL();
    return response;
  }
);

export const droplistSlice = createSlice({
  name: 'droplist',
  initialState: initialState,
  reducers: {
    resetAllData: () => {
      return initialState;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if(typeof payload === 'string'){
        state[payload] = initialState[payload];
      }else if(Array.isArray(payload)){
        payload.forEach(item => state[item] = initialState[item]);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBloodTypeDL.pending, (state) => {
        state.statusBloodType = 'loading';
      })
      .addCase(getBloodTypeDL.fulfilled, (state, action) => {
        state.statusBloodType = 'success';
        state.listBloodType = action.payload;
      })
      .addCase(getBloodTypeDL.rejected, (state) => {
        state.statusBloodType = 'error';
      })

      .addCase(getCountryDL.pending, (state) => {
        state.statusCountry = 'loading';
      })
      .addCase(getCountryDL.fulfilled, (state, action) => {
        state.statusCountry = 'success';
        state.listCountry = action.payload;
      })
      .addCase(getCountryDL.rejected, (state) => {
        state.statusCountry = 'error';
      })

      .addCase(getGenderDL.pending, (state) => {
        state.statusGender = 'loading';
      })
      .addCase(getGenderDL.fulfilled, (state, action) => {
        state.statusGender = 'success';
        state.listGender = action.payload;
      })
      .addCase(getGenderDL.rejected, (state) => {
        state.statusGender = 'error';
      })

      .addCase(getRaceDL.pending, (state) => {
        state.statusRace = 'loading';
      })
      .addCase(getRaceDL.fulfilled, (state, action) => {
        state.statusRace = 'success';
        state.listRace = action.payload;
      })
      .addCase(getRaceDL.rejected, (state) => {
        state.statusRace = 'error';
      })

      .addCase(getReligionDL.pending, (state) => {
        state.statusReligion = 'loading';
      })
      .addCase(getReligionDL.fulfilled, (state, action) => {
        state.statusReligion = 'success';
        state.listReligion = action.payload;
      })
      .addCase(getReligionDL.rejected, (state) => {
        state.statusReligion = 'error';
      })

      .addCase(getNationalityDL.pending, (state) => {
        state.statusNationality = 'loading';
      })
      .addCase(getNationalityDL.fulfilled, (state, action) => {
        state.statusNationality = 'success';
        state.listNationality = action.payload;
      })
      .addCase(getNationalityDL.rejected, (state) => {
        state.statusNationality = 'error';
      });
  }
});

export const { resetAllData, resetData } = droplistSlice.actions;

const droplistReducer = droplistSlice.reducer;
export default droplistReducer;